import React from "react";
import PropTypes from "prop-types";

import DialpadRenderer from "./DialpadRenderer";

const Dialpad = (props) => {
  const {
    style,
    itemRef,
    itemPosition,
    activePosition,
    elementDimensions,
    itemDimensions,
    canvasSize,
    discFillColor,
    discStrokeColor,
    circlesFillColor,
    circlesStrokeColor,
    circlesHighlightFillColor,
    circlesHighlightStrokeColor,
    circlesHighlightTextColor,
    textFillColor,
    textStrokeColor,
    arrowFillColor,
    arrowStrokeColor,
    callback,
  } = props;

  Dialpad.propTypes = {
    canvasSize: PropTypes.number,
    discFillColor: PropTypes.string,
    discStrokeColor: PropTypes.string,
    circlesFillColor: PropTypes.string,
    circlesStrokeColor: PropTypes.string,
    circlesHighlightFillColor: PropTypes.string,
    circlesHighlightStrokeColor: PropTypes.string,
    circlesHighlightTextColor: PropTypes.string,
    textFillColor: PropTypes.string,
    textStrokeColor: PropTypes.string,
    arrowFillColor: PropTypes.string,
    arrowStrokeColor: PropTypes.string,
    callback: PropTypes.func,
  };

  Dialpad.defaultProps = {
    canvasSize: 250,
    discFillColor: "transparent",
    discStrokeColor: "transparent",
    circlesFillColor: "black",
    circlesStrokeColor: "transparent",
    circlesHighlightColor: "red",
    textFillColor: "white",
    textStrokeColor: "transparent",
    arrowFillColor: "black",
    arrowStrokeColor: "transparent",
    circlesHighlightFillColor:"red",
    circlesHighlightStrokeColor:"transparent",
    circlesHighlightTextColor:"white",
    callback: () => {},
  };

  return (
    <DialpadRenderer
      style={style}
      itemRef={itemRef}
      itemPosition={itemPosition}
      activePosition={activePosition}
      elementDimensions={elementDimensions}
      itemDimensions={itemDimensions}
      canvasSize={canvasSize || 250}
      discFillColor={discFillColor || "transparent"}
      discStrokeColor={discStrokeColor || "transparent"}
      circlesFillColor={circlesFillColor || "black"}
      circlesStrokeColor={circlesStrokeColor || "transparent"}
      circlesHighlightFillColor={circlesHighlightFillColor || "red"}
      circlesHighlightStrokeColor={circlesHighlightStrokeColor || "transparent"}
      circlesHighlightTextColor={circlesHighlightTextColor || "white"}
      textFillColor={textFillColor || "white"}
      textStrokeColor={textStrokeColor || "transparent"}
      arrowFillColor={arrowFillColor || "black"}
      arrowStrokeColor={arrowStrokeColor || "transparent"}
      callback={
        callback ||
        (() => {
          // console.log("default callback");
        })
      }
    />
  );
};

export default Dialpad;
